import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue'
import PersonalRequestEditDialog from '@/components/format-edit/PersonalRequestEditDialog.vue'
import type { BasicData } from '@/utils/format-edit/basicData'

type SelectOption = {
  value: string
  label: string
}

type OptionGroup = {
  igCd?: string
  jgCd?: string
  label: string
  options?: SelectOption[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonalRequestFields',
  props: {
    mode: { default: 'fields' },
    formatData: null,
    basicData: null,
    formatId: null,
    industryData: null,
    jobTypeData: null,
    showAiCard: { type: Boolean, default: false },
    inlineAi: { type: Boolean, default: false },
    requestAiGenerated: { type: Boolean, default: false },
    requestAiLoading: { type: Boolean, default: false },
    requestAiError: { default: '' },
    bizreachIndustryGroups: { default: () => [] },
    bizreachJobCategoryGroups: { default: () => [] },
    getIndustryName: { type: Function, default: () => '' },
    getJobCategoryName: { type: Function, default: () => '' }
  },
  emits: ["update-basic-data", "update-format-data"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update-basic-data', payload: Record<string, unknown>): void
  (e: 'update-format-data', payload: Record<string, unknown>): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { mode: 'fields' | 'ai-card', formatData: Record<string, unknown>, basicData: BasicData, formatId: string, industryData: OptionGroup[], jobTypeData: OptionGroup[], showAiCard: boolean, inlineAi: boolean, requestAiGenerated: boolean, requestAiLoading: boolean, requestAiError: string, bizreachIndustryGroups: OptionGroup[], bizreachJobCategoryGroups: OptionGroup[], getIndustryName: (cd: unknown) => string, getJobCategoryName: (cd: unknown) => string };





const requestEditDialogVisible = ref(false)

function emittedBasicField(key: keyof BasicData) {
  return computed({
    get: () => props.basicData[key],
    set: (value: unknown) => emit('update-basic-data', { [key]: value })
  })
}

function emittedFormatField(key: string) {
  return computed({
    get: () => props.formatData[key],
    set: (value: unknown) => emit('update-format-data', { [key]: value })
  })
}

const yakushokuBusho = emittedBasicField('yakushokuBusho')
const gyoushuCd = emittedBasicField('gyoushuCd')
const shokushuCd = emittedBasicField('shokushuCd')
const kibouGyoushuCd = emittedBasicField('kibouGyoushuCd')
const kibouShokushuCd = emittedBasicField('kibouShokushuCd')
const nowNensyu = emittedFormatField('nowNensyu')
const kibouNensyu = emittedFormatField('kibouNensyu')
// 3択だった時期（2026-03〜09）の保存値「400万円以上」などは数値欄に表示できない。
// 値は書き換えずに欄の下に出し、数字を入力したら置き換わる
const nowNensyuLegacyLabel = computed(() => {
  const value = String(nowNensyu.value ?? '')
  return value && Number.isNaN(Number(value)) ? value : ''
})

function labelForCd(groups: OptionGroup[] | undefined, cd: unknown): string {
  if (!cd) return ''
  for (const group of groups || []) {
    for (const item of group.options || []) {
      if (item && item.value === cd) return item.label
    }
  }
  return ''
}

onMounted(() => {
  if (!('currentIndustrycategory' in props.formatData)) {
    emit('update-format-data', { currentIndustrycategory: '' })
  }
  if (!('currentJobcategory' in props.formatData)) {
    emit('update-format-data', { currentJobcategory: '' })
  }
})

watch(
  () => props.basicData.gyoushuCd,
  (newCd) => {
    emit('update-format-data', {
      currentIndustrycategory: labelForCd(props.industryData, newCd)
    })
  }
)
watch(
  () => props.basicData.shokushuCd,
  (newCd) => {
    emit('update-format-data', {
      currentJobcategory: labelForCd(props.jobTypeData, newCd)
    })
  }
)

return { __sfc: true,props, emit, requestEditDialogVisible, emittedBasicField, emittedFormatField, yakushokuBusho, gyoushuCd, shokushuCd, kibouGyoushuCd, kibouShokushuCd, nowNensyu, kibouNensyu, nowNensyuLegacyLabel, labelForCd, PersonalRequestEditDialog }
}

})